<template>
<div class="judges section" id="judge">
  <div class="layout-content" v-for="(judgesType, j) in data" :key="j">
    <SubTitle class="sub-title" :text="judgesType.title.h1" :tip="judgesType.title.tip" />

    <div class="content">
      <div class="content-item" v-for="(item, index) in judgesType.list" :key="index">
        <img class="content-img" :src="item.headImg" alt="">
        <div class="content-text">
          <p class="content-text-name">{{item.name}}</p>
          <p class="content-text-title" v-html="item.title" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SubTitle from '@/components/SubTitle'

export default {
  data: () => ({
    bgHoverMemory: {}
  }),
  props: ['data'],
  components: {
    SubTitle
  },

  methods: {
    mouseenterHandler (i) {
      this.$set(this.bgHoverMemory, i, true)
    },
    mouseleaveHandler (i) {
      this.$set(this.bgHoverMemory, i, false)
    }
  }
}
</script>

<style lang="scss" scoped>
.section {

}

.judges {
  background: $bgGrey;
  color: #303030;
}

.content {
  display: flex; flex-wrap: wrap; justify-content: space-between;
  margin-top: 5px;
}

.content-item {
  margin-bottom: 60px;

  @include mobile {
    width: calc(calc(100% - 15px) / 2);
    margin-bottom: 25px;
  }

  &:nth-child(n+4) {
    margin-bottom: 0;
  }
}

.content-img {
  width: 322px;

  @include mobile {
    width: 100%;
    // width: 160px; height: 136px;
  }
}

.content-text {
  box-sizing: border-box;
  width: 322px; height: 168px;
  padding: 26px 24px 28px;
  background: $white;

  @include mobile {
    width: 100%; height: 130px;
    padding: 14px 14px 18px;
  }
}

.content-text-name {
  font-size: 20px; font-family: Alibaba-PuHuiTi-Heavy;
  color: #000000;
  line-height: 30px;

  @include mobile {
    margin-bottom: 6px;
    font-size: 14px;
    line-height: 20px;
  }
}

.content-text-title {
  font-size: 14px; font-weight: 400;
  color: #000000;
  line-height: 28px;

  @include mobile {
    font-size: 11px;
    line-height: 18px;
  }
}

@include mobile {
}
</style>
